import Vue from 'vue'
import errorHandler from '@/utils/errorHandler'

export default (conceptId, type) => {
  const fetchUrl = `purchase/quantification/concept/${type}-work-generator/${conceptId}/`;
  return errorHandler(Vue.$http.get(fetchUrl))
  .then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${type}_work_generator.pdf`)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
    .catch((err) => {
      throw err
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/fetchWorkGenerator.js